import {EmbeddedListView} from "./edit/EmbeddedListView";

export class PopupListView {
    constructor(presenter, block) {
        let that = this;
        that.presenter = presenter;
        that.block = block;
    }

    show() {
        let that = this;
        let dialog = $("<div id='listViewPopup'></div>");
        that.dialog = dialog;
        dialog.kendoWindow({
            width: "75%",
            modal: true,
            resizable: true,
            scrollable: true,
            draggable: true, position: {
                top: "10%",
                left: "10%"
            },
            close: function (e) {
                dialog.data("kendoWindow").destroy()
            }
        });
        let embeddedListView = new EmbeddedListView({
            owner: that,
            block: that.block,
            editPresenter: that.presenter,
            dialogBox: that
        });
        dialog.append(embeddedListView.createElement());
        dialog.data("kendoWindow").open();
        embeddedListView.afterAttach();
    }

    hide() {
        let that = this;
        if (!that.dialog)
            return;
        that.dialog.data("kendoWindow").destroy();
    }

    rootElement() {
        return this.dialog;
    }
}
